<template>
  <div class="er">
    <ul class="er_ul">
      <li class="er_li" :class="idx == 0 ? 'bj' : ''" @mousemove="changeBJ(0)">
        新闻动态
      </li>
      <li class="er_li" :class="idx == 1 ? 'bj' : ''" @mousemove="changeBJ(1)">
        工作动态
      </li>
      <li class="er_li" :class="idx == 2 ? 'bj' : ''" @mousemove="changeBJ(2)">
        政策文件
      </li>
    </ul>
    <ul class="er_news">
      <li
        class="er_newsli"
        v-for="(item, index) in newsList[idx].slice(
          (currentpage - 1) * pagesize,
          currentpage * pagesize
        )"
        :key="index"
      >
        <router-link :to="{ name: '新闻详情',query:{id:item.id} }" target="_blank"
          >{{item.title}}</router-link
        >
        <p>{{item.logintime.substr(0,10)}}</p>
      </li>
    </ul>
    

    <div>
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        layout="prev, pager, next, jumper"
        :total="newsList[idx].length"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idx: 0,
      pagesize: 10,
      currentpage: 1,
      inputpage: 1,

      newsList: [],
    };
  },
  created() {
    this.idx = this.$route.query.id ? this.$route.query.id : 0;
    this.newsList[0] = this.ajax_news("lunbo1").data;
    this.newsList[1] = this.ajax_news("getgongzuodongtai").data;
    this.newsList[2] = this.ajax_news("getzhengcewenjian").data;
  },
  mounted() {
    
  },
  computed: {},
  watch: {},
  methods: {
    changeBJ(i) {
      this.idx = i;
      this.currentpage = 1;
      this.inputpage = 1;
    },
    // 当前每夜多少条
    handleSizeChange(size) {
      this.pagesize = size;
    },
    // 当前页数
    handleCurrentChange(currentpage) {
      this.currentpage = currentpage;
    },
  },
};
</script>

<style scoped>
.er {
  display: block;
  margin: 0 auto;
  margin-top: 60px;
  padding-bottom: 90px;
  width: 1720px;
  height: auto;
  /* background-color: navy; */
}
.er_ul {
  padding: 0 540px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 640px;
  height: 77px;
  border-bottom: 1px solid #77a5df;
}
.er_li {
  width: 112px;
  height: 71px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 71px;
  color: #666666;
  border-bottom: 6px solid #77a6df00;
  cursor: pointer;
}
.bj {
  color: #77a5df;
  border-bottom: 6px solid #77a6df;
}
.er_news {
  display: block;
  padding-left: 300px;
  padding-top: 57px;
  width: 1420px;
  height: auto;
  /* background-color: navy; */
}
.er_newsli {
  width: 1200px;
  height: 72px;
  overflow: hidden;
  margin-bottom: 40px;
}
.er_newsli a {
  display: block;

  width: 1200px;
  height: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 31px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  line-height: 31px;
  color: #333333;
}
.er_newsli p {
  display: block;
  padding-top: 15px;
  width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  line-height: 26px;
  color: #999999;
}
.el-pagination {
  text-align: center;
}
</style>
